import AlertBannerList from '@/components/Banner/AlertBannerList';
import IFrameContent from '@/components/common/IFrameContent';
import { useGetHomePageQuery } from '@/features/api/endpoints/LayoutEndpoints';
import type { IFrameLinkParams } from '@/models/common.type';
import type { Banner, HomePageBanner } from '@/models/types';
import { Box, Center, Divider, Loader } from '@mantine/core';
import { useDocumentTitle } from '@mantine/hooks';
import { useTranslate } from '@tolgee/react';
import isObject from 'lodash/isObject';

const HomePage = () => {
  const { t } = useTranslate();

  useDocumentTitle(t('app.title'));

  const { data, isLoading } = useGetHomePageQuery();

  if (isLoading) {
    return (
      <Center h={150}>
        <Loader />
      </Center>
    );
  }

  if (!data) {
    return null;
  }

  const paramsZone1 = data.zone1Params as unknown as IFrameLinkParams;
  const paramsZone2 = data.zone2Params as unknown as IFrameLinkParams;

  const banners = Array.isArray(data?.banners)
    ? data.banners.reduce((acc: Banner[], current: HomePageBanner) => {
        if (isObject(current.Banner_id)) {
          acc.push(current.Banner_id);
        }
        return acc;
      }, [])
    : [];

  return (
    <Box>
      <AlertBannerList items={banners} />
      {data.zone1Link && (
        <Box>
          <IFrameContent link={data.zone1Link} params={paramsZone1} />
        </Box>
      )}
      {data.zone1Link && data.zone2Link && <Divider my="md" />}
      {data.zone2Link && (
        <Box>
          <IFrameContent link={data.zone2Link} params={paramsZone2} />
        </Box>
      )}
    </Box>
  );
};

export default HomePage;
